import * as PIXI from "pixi.js";
import Layers from "../layers/Layers";
import { Coord } from "../types/Interface";


export default class PointTag extends PIXI.Text {
  private Layers = Layers.getInstance();
  constructor(name: string) {
    super()
    this.text = name;
    this.style.fontSize = 35;
    this.anchor.set(.5);
    this.x = -50;
    this.y = -50;
    this.addToLayer();
  }
  private addToLayer = () => this.Layers.Info.addChild(this);
  updateCoord = (coord: Coord) => Object.assign(this, coord);
}